import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';

import Header from './Header';
import Footer from './Footer';

import pages from './data/pages';


function App() {

  const BASE_URL = "https://jsonplaceholder.typicode.com/";

  const { pathname } = useLocation();

  //initialization Code
  useEffect(() => {
    window.addEventListener('scroll', function() {
      const header = document.getElementById('navbar');
      if (window.scrollY === 0 ) {
        header.classList.add('expanded');
      } else {
        header.classList.remove('expanded');
      }
    });
  }, [])
  
  

  useEffect(() => {
    // Scroll instantly to the top
    window.scrollTo(0, 0);

    const hash = window.location.hash;
    if (hash){
      // Delay smooth scrolling to the hashed element
    
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth' });
        }, 100); // Adjust delay as needed
      }
      
    }
  }, [pathname]);

  return (
    <div className="App">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default App;
